import {setSmoother,gsap, ScrollSmoother, ScrollTrigger, SplitText, forceScrollSmootherUpdate, smoother, Flip} from "./gsap";
import {documentReady, observeElementResize, debouncer, scrollToEl } from "./utils";
import { LinesAnimator } from './lines-animator';
import { MagneticImage } from "./magnetic-images";
import wrap from "./element-wrapper";
import { InitScrollBasedImageSlider } from "../components/scroll-based-slider";

const getCurrentScrollInPixels = () => {
    // function matrixToArray(str) {
    //     return str.match(/(-?[0-9\.]+)/g);
    // }
    const pageEl = document.querySelector('#page');
    // var style = window.getComputedStyle(pageEl);
    // var matrix = matrixToArray(style.transform);
    // console.log('translateX: ', matrix.m41);
    const style = window.getComputedStyle(pageEl)
    const matrix = new DOMMatrixReadOnly(style.transform)
    return {
        translateX: matrix.m41,
        translateY: matrix.m42
    }
}

const InitializeSmoothing = () => {
    
    gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText, Flip);
    
    ScrollTrigger.config({ 
        ignoreMobileResize: true,
        refreshPriority: 9,
    })
    
    documentReady(()=>{
        observeElementResize(document.querySelector('#page'), ()=>{
            forceScrollSmootherUpdate(); 
        });

        // If the page lands on a url with an anchor, update smooth scroll to
        // that position
        const hash = window.location.hash;
        const target = hash ? document.querySelector(hash) : null;
        if(!!target){
            setTimeout(()=> {
                if(smoother){
                    ScrollSmoother.get().scrollTo(target, true);
                }
                else {
                    scrollToEl(target);
                }
            }, 1000);
        }

    })
    
    //no scrollsmoother on mobile - too glitchy on ios
    if (!ScrollTrigger.isTouch) {
        // const scrollEl = document.querySelector('.site');
        // scrollEl.classList.add('scroll-smoother-site');
        // setSmoother(ScrollSmoother.create({
        //     wrapper: ".scroll-smoother-wrapper",
        //     content: ".site",
        //     smooth: .1,
        //     ease:"power4.out",
        //     effects: true,
        //     ignoreMobileResize: true,
        //     normalizeScroll: true,
        //     smoothTouch: 0.1,
        // }));
    }

}

const InitializeSmoothAnchorLinks = () => {

    document.querySelectorAll("a[href^='#']").forEach((a) => {

        const linkHandler = (e) => {
            e.preventDefault();
            if(!a.hash == '#' || a.hash){
                if('preventDefault' in a.dataset) return;
                
                if(smoother){
                    ScrollSmoother.get().scrollTo(a.hash, true);
                }
                else {
                    const target = document.querySelector(a.hash);
                    scrollToEl(target);
                }
                window.history.pushState({}, "", a.hash);
            }
        };

        //no doubling up event listeners
        a.removeEventListener("click", linkHandler);
        a.addEventListener("click", linkHandler);
    });



}

const InitializePinContainers = () => {

    document.querySelectorAll( '.pin-container' ).forEach( pc => {

        const p = [...pc.querySelectorAll(':scope > *')].filter(n => !n.classList.contains('headline-area')).reduce( (shortest, cur) => {
            return cur.scrollHeight > shortest.scrollHeight ? shortest : cur;
        });

        let topSpacing = (window.innerHeight * 0.5) - (p.offsetHeight * 0.5);

        if( topSpacing < 50 ) {
            topspacing = 50;
        }

        ScrollTrigger.matchMedia({
            "(min-width:991px)": () => {
                ScrollTrigger.create({
                    trigger: p,
                    start: `top ${topSpacing}px`,
                    endTrigger: pc,
                    end: () => {
                        const bottomPadding = window.getComputedStyle(pc, null).getPropertyValue('padding-bottom')
                        const offsetHeight = p.offsetHeight + topSpacing;
                        return `bottom-=${bottomPadding} top+=${offsetHeight}`;
                    },
                    scrub: true,
                    pin: true,
                    pinSpacing: false,
                });
            }
        })
    });

}

const InitializeMediaAnimations = ( scope ) => {
    scope = scope ?? document;
    const mediaBlocks = scope.querySelectorAll('.media-block:not(.transition-target) .media-block-media');
    const matchMediaMediaBlocks = gsap.matchMedia(mediaBlocks);
    mediaBlocks.forEach( m => {

        if( m.classList.contains('animate-complete') ) {
          return;
        }

        m.classList.add('animate-complete');

        matchMediaMediaBlocks.add('(prefers-reduced-motion:no-preference',()=>{
            const animationYOffset = "25%";

            const transition = gsap.from(m, {
                rotation:4,
                autoAlpha: 0,
                y: animationYOffset,
                duration:1.5,
                delay: 0.25,
                ease: "Expo.easeInOut",
                onStart: () => {
                    m.parentNode.style.setProperty('clip-path', 'polygon(0 0, 100% 0, 100% 100%, 0 100%)');
                },
                onComplete: () => {
                    m.parentNode.style.setProperty('clip-path', 'unset');

                    // Check for lazy load custom properties
                    let lazySizes = {};
                    const styles = getComputedStyle(m);
                    if(styles.getPropertyValue("--lazy-width")){
                        lazySizes.width = styles.getPropertyValue("--lazy-width");
                        lazySizes.height = styles.getPropertyValue("--lazy-height");
                    }
                    
                    gsap.set(transition.targets(), { clearProps: "all" });

                    if(lazySizes.width){
                        m.style.setProperty('--lazy-width', lazySizes.width);
                        m.style.setProperty('--lazy-height', lazySizes.height);
                    }

                    if( m.parentElement.tagName === "A" || m.parentElement.parentElement.tagName === "A") {
                        m.magnet = new MagneticImage(m);
                    }
                }
            });

            ScrollTrigger.create({
                trigger: m,
                animation: transition,
                start: `top-=${animationYOffset} 125%`,
                toggleActions: 'play none none none',
                once: true
            });
        })


    });

    const fadeUps = [
        ...scope.querySelectorAll('.btn, .cta, .inline-btn'),
        ...scope.querySelectorAll(':is(.copy-area, .copy-grid:not(.as-slider)) :is(p):not(.animated-fade-up)'),
        ...scope.querySelectorAll('.animated-fade-up:not(.is-logo-animation)')
    ];

    fadeUps.forEach( m => {

        if( m.classList.contains('animate-complete') ) {
          return;
        }

        m.classList.add('animate-complete');

        const animationYOffset = "25%";
        // m.wrapped = wrap(m, [], 'p');

        const transition = gsap.from(m, {
            // rotate: 1,
            alpha: 0,
            y: animationYOffset,
            duration:0.85,
            delay:0.15,
            ease: "Sine.easeInOut",
            onStart: () => {
                // m.parentNode.style.setProperty('clip-path', 'polygon(0 0, 100% 0, 100% 100%, 0 100%)');
            },
            onComplete: () => {
                // m.parentNode.style.setProperty('clip-path', 'unset');
                // m.wrapped.unwrap();
                // gsap.set(transition.targets(), { clearProps: "all" });
            }
        });

        ScrollTrigger.create({
            trigger: m,
            animation: transition,
            start: `top 125%`,
            toggleActions: 'play none none none',
            once: true,
        });
    });

    const linesAnimations = [
        ...scope.querySelectorAll(':is(.copy-area, .copy-grid) :is(h1, h2, h3, h4, h5, h6):not(:is(.animated-line-heading, .animate-complete))'),
        ...scope.querySelectorAll(':is(.headline-area) :is(p, h1, h2, h3, h4, h5, h6):not(:is(.animated-line-heading, .animate-complete))'),
        ...scope.querySelectorAll('.animated-line-heading:not(.animate-complete)')
    ]

    linesAnimations.forEach( el => {
        if( !el.animator ) {
            el.animator = new LinesAnimator( el );
        }
    });
}



const InitDocumentationMenuState = () => {
    const menu = document.querySelector('.documentation-nav');
    
    if(!!menu){
        const menuLinks = menu.querySelectorAll('li a');

        menuLinks.forEach(link => {
            const hash = link.getAttribute('href');
            const target = document.querySelector(hash);
            
            if(!!target){
                ScrollTrigger.create({
                    trigger: target,
                    start: 'top center',
                    end: 'bottom center',
                    onEnter: ()=>{
                        link.classList.add('active');
                    },
                    onEnterBack: () => {
                        link.classList.add('active');
                    },
                    onLeave: () => {
                        link.classList.remove('active');
                    },
                    onLeaveBack: () => {
                        link.classList.remove('active');
                    }
                });
            }
        });
    }
}


export const InitializeMediaBlockParallaxing = () => {
    const cards = document.querySelectorAll('.media-block.type_post .media-block-lazy-wrap .media-block-link, .media-block-wrapper.post_type_work .media-block-lazy-wrap .media-block-link, .results_card.has_parallax_img .results_card__img');
    if(cards){
        cards.forEach(el => {
            const img = el.querySelector('img');
    
            if(!!img && !el.classList.contains('parallax-set')){
                el.classList.add('parallax-set');
    
                let parallax = gsap.timeline({
                    scrollTrigger: {
                        trigger: el,
                        scrub: true,
                        invalidateOnRefresh: true,
                        // markers:true,
                        start: () => {
                            // Dynamic loading and page resizing make the start/end positions 
                            // unpredictable. This will ensure the markers are placed correctly.
                            const currentScroll = smoother ? getCurrentScrollInPixels().translateY * -1 : 0;
                            return "top+=" + currentScroll + " bottom";
                        },
                        end: () => {
                            const currentScroll = smoother ? getCurrentScrollInPixels().translateY * -1 : 0;
                            return "bottom+=" + currentScroll + " 15%";
                        },
                    },
                });
        
                parallax.fromTo(
                    img,
                    {
                        yPercent: -16.666,
                        scale: 1.1,
                        // height: '120%'
                    },
                    {
                        yPercent: 0,
                        scale:1,
                        // height:'100%'
                    }
                );
            }
        });
    }
}

const InitializeGSAPOnPageLoad = () => {

    InitializeSmoothing();

    window.addEventListener("load", (e) => {
        if (window.location.hash && smoother) {
            ScrollSmoother.get().scrollTo(window.location.hash, true);
        }
    });

    InitializeSmoothAnchorLinks();
    InitializePinContainers();
    // InitializeMediaAnimations();
    InitializeMediaBlockParallaxing();
    InitScrollBasedImageSlider();
    InitDocumentationMenuState();

}

const InitializeGSAPOnNavigate = () => {

    InitializeSmoothAnchorLinks();
    InitializePinContainers();
    // InitializeMediaAnimations();
    InitializeMediaBlockParallaxing();
    InitScrollBasedImageSlider();
    InitDocumentationMenuState();
}

export { gsap, InitializeGSAPOnPageLoad, InitializeGSAPOnNavigate }
